import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=553a5346&scoped=true"
import script from "./Archives.vue?vue&type=script&lang=js"
export * from "./Archives.vue?vue&type=script&lang=js"
import style0 from "../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Archives.vue?vue&type=style&index=1&id=553a5346&prod&lang=scss"
import style2 from "./Archives.vue?vue&type=style&index=2&id=553a5346&prod&lang=scss&scoped=true"
import style3 from "./Archives.vue?vue&type=style&index=3&id=553a5346&prod&lang=scss&scoped=true"
import style4 from "./Archives.vue?vue&type=style&index=4&id=553a5346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553a5346",
  null
  
)

export default component.exports